import React from 'react';
import SectionItem from './SectionItem';
import { getOrgAddInfoArray } from '../../common/objectToArray';

const SectionContent = ({
	body,
	parentId,
	params,
	orgConfig,
	setBody,
	showAddMore = true,
	type,
	errors,
	edit,
	leadId,
	title
}) => {
	const addNewSection = e =>
		setBody(values => {
			return {
				...values,
				...body,
				[parentId]: [...body[parentId], {}]
			};
		});

	const removeSection = index => {
		const changes = body[parentId].filter((section, idx) => idx !== index);
		setBody(values => {
			return { ...values, ...body, [parentId]: changes };
		});
	};
	if (type === 'multiple')
		return (
			<>
				{(body[parentId] || []).map(({}, parentIndex) => (
					<>
						{parentIndex == 0 && (
							<>
								<p style={{ fontSize: '13px', color: '#ea652b', marginTop: '-5px' }}>{`${title?.split(' ')[0]} Info ${parentIndex + 1}`}</p>
							</>
						)}
						<div className='row mt-3'>
							{getOrgAddInfoArray(orgConfig[parentIndex] ?? params).map(({ label, value, id, rule, hint }, index) => (
								<SectionItem
									required={value}
									parentIndex={parentIndex}
									type={type}
									body={body}
									setBody={setBody}
									parentId={parentId}
									label={label}
									hint={hint}
									key={index}
									id={id}
									rule={rule}
									sectionIndex={index}
									params={getOrgAddInfoArray(orgConfig[parentIndex] ?? params)}
									errors={errors}
									edit={edit}
									leadId={leadId}
								/>
							))}

							{showAddMore && parentIndex >= 1 && (
								<div className='col-md-4'>
									<div className='form-group'>
										<i
											onClick={() => removeSection(parentIndex)}
											className='fa fa-minus-circle'
										></i>
									</div>
								</div>
							)}
						</div>
						{(body[parentId] || []).length - 1 !== parentIndex && (
							<>
								<hr className='' style={{'background': 'rgb(213, 213, 213)'}}/>
								<p style={{ fontSize: '13px', color: '#ea652b', marginTop: '-12px' }}>{`${title?.split(' ')[0]} Info ${parentIndex + 2}`}</p>
							</>
						)}
					</>
				))}

				{showAddMore &&
					((leadId && edit) || !leadId) &&
					type === 'multiple' && (
						<i onClick={addNewSection} className='fa fa-plus-circle'></i>
					)}
			</>
		);

	return (
		<div className='row mt-3'>
			{params.map(({ label, value, id, rule, hint }, index) => (
				<SectionItem
					required={value}
					body={body}
					setBody={setBody}
					parentId={parentId}
					label={label}
					hint={hint}
					key={index}
					id={id}
					rule={rule}
					params={params}
					errors={errors}
					edit={edit}
					leadId={leadId}
				/>
			))}
		</div>
	);
};

export default SectionContent;
